const styles = theme => ({
  filtersContainer: {
    display: 'flex',
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.borderColor}`,
    // borderRadius: '6px',
    marginTop: '16px',
    overflow: 'hidden',
    '& $filterBtn:not(:last-of-type)': {
      borderRight: `1px solid ${theme.palette.primary.borderColor}`,
    },
  },
  filterBtn: {
    flex: '1',
    color: theme.palette.primary.adgmSpace,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '21px',
    padding: '12px',
    borderRadius: '0',
    '&:hover': {
      background: theme.palette.primary.white,
      color: theme.palette.primary.adgmSpace,
    },
  },

  selectedFilterBtn: {
    color: theme.palette.primary.adgmBlack,
    fontWeight: '500',
    background: theme.palette.primary.adgmGreenLight,
    boxShadow: 'inset 2px 2px 5px rgba(28, 153, 155, 0.25)',
    // borderRight: '0',
    '&:hover': {
      background: theme.palette.primary.adgmGreenLight,
      color: theme.palette.primary.adgmGreen,
    },
  },
});

export default styles;
